/*
 * @Description:
 * @Author: liXinMan
 * @Date: 2021-12-14 10:04:45
 * @LastEditors: liXinMan
 * @LastEditTime: 2021-12-17 11:33:13
 */

// 注意：一定是 exports，不是 export，否则会报错，报错信息是下列的中的内容不是 string
module.exports = {
	// images: {
	// 	listUploadBtn: '../../public/static/images/list-uploadBtn-en.png'
	// },

	works: {
		text: 'Дорогие ребята! 4 февраля 2022 года открываются зимние Олимпийские игры в Пекине. Телеканал«CGTN-Русский» и международная медиагруппа «Россия сегодня» объявляют о начале китайско-российской художественной онлайн-выставки "Зимняя Олимпиада глазами детей". Если тебе не больше 15 лет, если ты любишь рисовать – добро пожаловать к нам! Прояви воображение и нарисуй зимнюю Олимпиаду в Пекине такой, какой ты её видишь! Давайте все вместе пожелаем белой Олимпиаде в Пекине успеха, а спортсменам - новых рекордов и достижений! Это мероприятие пройдет при поддержке Китайского культурного центра в Москве и Российского культурного центра в Пекине. Ждем вашего участия!'
	},
	uploadWork: {
		workName: 'Название творческой работы',
		creator: 'Имя, фамилия',
		age: 'Возраст',
		nationality: 'Гражданство',
		// buttonInfo: 'подтвердить загрузку ',
		uploadInfo: 'Загрузить работу',
		uploadMsg: 'Формат изображения JPG. Файл не более 5MB.Загрузить по одному изображению.',
		inputMsg: 'Ввести на китайском или русском языке'
	},
	work: {
		logo: 'Logo',
		workName: 'Название творческой работы',
		creator: 'Имя, фамилия',
		age: 'Возраст',
		nationality: 'Гражданство',
		// buttonInfo: 'ещё больше произведение'
	}
}
